import { FC } from 'react';

import PartnersSection from './PartnersSection';

const ClientsSection: FC = () => {
  return (
    <>
      {/* Client Testimonials */}
      <section className="bg-white py-16 pt-32 mt-[100vh]">
      <PartnersSection />  
      </section>

    </>
  );
};

export default ClientsSection;


